export default {"src":"/_next/static/media/like.c9d27438.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};